import { DiscountTypes } from "@/common/enums";

export default class GlobalPaymentsSettingsModel {        
    merchantId: string = "";
}
